import { parseEntities } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import DossierEvent from '../models/DossierEvent';

const SCHEMA = {
  createdOn: (data: any) => parseMoment(data.eventOn),
  createdBy: (data: any) => User.withFullName(data.eventBy),
  description: 'eventDescription',
  comment: 'comment',
};

export function parseDossierEvents(data: any): Array<DossierEvent> {
  return parseEntities(data, SCHEMA, DossierEvent);
}
